<template>
  <v-container
    id="test-results"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          v-if="$can('read', 'testing')"
          icon="mdi-test-tube"
        >
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('testing.results') }}
            </div>
          </template>
          <v-row>
            <v-col
              cols="12"
              md="12"
              style="display:flex"
            >
              <v-combobox
                v-model="targetProject"
                :items="availableProjects"
                item-text="title"
                item-value="id"
                :label="$t('testing.projects')"
              />
              <v-btn
                color="green darken-1"
                class="ma-2"
                :disabled="targetProject.id.length != 8"
                @click="loadProject"
              >
                {{ $t('testing.load') }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="12"
              class="headline"
            >
              {{ testResults.title }}
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <div
                v-for="question in testResults.questionSet"
                :key="question.id"
                class="body-1 ma-5"
              >
                {{ $t('testing.question') }}#{{ question.id + 1 }}: {{ question.question }}

                <div
                  v-for="tester in testResults.testers"
                  :key="tester.id"
                  class="body-2 ml-5"
                >
                  {{ tester.tester.firstName + ' ' + tester.tester.lastName + `\'s ${ $t('testing.answer')}: ` }}
                  {{ tester.answers[question.id] }}
                </div>
              </div>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { fetchTestResults } from '@/firebase'
  export default {
    components: { },
    data: () => ({
      targetProject: { id: '', title: '' },
      availableProjects: [],
      testResults: {},
    }),
    mounted () {
      this.loadAvailbleProject()
    },
    methods: {
      loadProject () {
        fetchTestResults(this.targetProject.id)
          .then(results => {
            if (results) {
              this.testResults = results
            } else {
              this.testResults = { title: 'Project not found', questionSet: [], testers: [] }
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      loadAvailbleProject () {
        fetchTestResults('all')
          .then(results => {
            results.forEach(test => {
              this.availableProjects.push({ title: test.title, id: test.id })
            })
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  }
</script>
